$(function () {
  if ($('.js-stories-slider').length) {
    var videoArray = [];
    var videoTimer = null;
    var start = 0;
    var end = null;
    var activeUser = 0;

    var setActiveVarSet = function() {
      var activeElem = $('[data-user="'+ activeUser +'"]');

      start = activeElem.first().index();
      end = activeElem.last().index();
    };

    $('.js-stories-slider').each(function () {
      var storiesSlider = new Swiper('.js-stories-slider', {
        slidesPerView: 1,
        speed: 300,
        effect: 'fade',
        autoplay: {
          delay: 5000,
        },
        centeredSlides: true,
        navigation: {
          nextEl: '.js-stories-button-next',
          prevEl: '.js-stories-button-prev'
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true
        },
        breakpoints: {
          768: {
            slidesPerView: 1
          }
        },
        on: {
          slideChangeTransitionStart: function () {
            clearInterval(videoTimer);
            pauseAllVideos();
            if (!videoArray[this.realIndex]) this.autoplay.start();
            if (this.slides.length === this.realIndex + 1) this.autoplay.stop();


            if (this.realIndex < start) {
              activeUser--;
              setActiveVarSet();
              setAndRemoveDisableClass(true);
              setActivePagination();
            } else if (this.realIndex > end) {
              activeUser++;
              setActiveVarSet();
              setAndRemoveDisableClass(false);
              setActivePagination();
            }

            $('.swiper-pagination-bullet').css('transition-duration','0s');
            var _self = this;
            if (videoArray[this.realIndex]) {
              _self.autoplay.stop();
              videoArray[this.realIndex].play();

              videoTimer = setInterval(function () {
                if(videoArray[_self.realIndex].currentTime >= videoArray[_self.realIndex].duration) {
                  _self.slideNext(300);
                  _self.autoplay.start();
                }
              },1000);

              $('.swiper-pagination-bullet-active').css('transition-duration',videoArray[_self.realIndex].duration + 's');
            } else {
              $('.swiper-pagination-bullet-active').css('transition-duration','5s');
            }

          },
          init: function () {
            $('.js-story-slide:not([data-user="0"])').addClass('disable');
            setActiveVarSet();
            setTimeout(function () {
              setActivePagination();
              $('.swiper-pagination-bullet').removeClass('swiper-pagination-bullet-active');
            },1000);
          }
        }
      });
      storiesSlider.autoplay.stop();

      $('.js-story-slide').each(function (id, el) {
        var videoExist = $(el).find('.js-story').length;
        var videoPlayer = $(el).find('.js-story');

        if (videoExist) {
          var player = new Plyr(videoPlayer, {
            controls: ['play-large', 'play', 'progress', 'current-time', 'mute'],
            noCookie: false,
            rel: 0,
            showinfo: 0,
            iv_load_policy: 3,
            modestbranding: 1,
            playsinline: true,
          });
          addToVideoArr(player);
        } else {
          addToVideoArr(null);
        }
      });

      function addToVideoArr(val) {
        videoArray.push(val);
      }

      var pauseAllVideos = function() {
        for (var i = 0;videoArray.length > i;i++) {
          if (videoArray[i]) videoArray[i].stop();
        }
      };

      var setActivePagination = function () {
        $('.swiper-pagination-bullet').hide();
        for (var i = start; end >= i; i++) {
          $('.swiper-pagination-bullet').eq(i).fadeIn();
        }
      };

      function setAndRemoveDisableClass(isSubtraction) {
        $('[data-user="' + activeUser + '"]').removeClass('disable');

        var disableUser = isSubtraction ? activeUser + 1: activeUser - 1;
        setTimeout(function () {
          $('[data-user="' + disableUser + '"]').addClass('disable');
        },300);
      }

      window.storiesSlider = storiesSlider;
      window.videoArray = videoArray;
      window.pauseAllVideos = pauseAllVideos;
      window.setActiveVarSet = setActiveVarSet;
      window.activeUser = activeUser;
      window.start = start;
    });
  }

});
